import { render, staticRenderFns } from "./ProjectSettingsCard.vue?vue&type=template&id=01448f20&"
import script from "./ProjectSettingsCard.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports